import { useRef, useState } from 'react';
import { ArrowLeftIcon } from '../../../../assets/icons'; 
import classes from '../styles.module.scss'
import { useKato } from '../../../../contexts/kato.context';
import { getImageById } from '../../../../requests/public.request';
import Modal from '../../../../components/modal/modal.component';

const Photos = () => {
    const { imageIds } = useKato().katoGeneralInfo || { imageIds: [] };
    const containerRef = useRef<HTMLDivElement>(null);
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

    const scrollAmount = 12.5 * 16 + 0.625 * 2 * 16; // ширина item + gap + padding (в px)

    const scrollLeft = () => {
        containerRef.current?.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    };

    const scrollRight = () => {
        containerRef.current?.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    };

    const handlePrev = () => {
        if (selectedIndex === null) return;
        setSelectedIndex((prev) => (prev! > 0 ? prev! - 1 : imageIds.length - 1));
    };

    const handleNext = () => {
        if (selectedIndex === null) return;
        setSelectedIndex((prev) => (prev! < imageIds.length - 1 ? prev! + 1 : 0));
    };

    if (!imageIds || imageIds.length === 0) return null;

    return (
        imageIds && <div className={classes.photos}>
            <button className={classes.photos__arrow + ' ' + classes.left} onClick={scrollLeft}>
                <ArrowLeftIcon />
            </button>
            <div className={classes.photos__container} ref={containerRef}>
                {imageIds.map((id, index) => (
                    <div 
                        className={classes.photos__item} 
                        key={index} 
                        onClick={() => setSelectedIndex(index)}
                    >
                        <img src={getImageById(id)} alt={`photo-${index}`} />
                    </div>
                ))}
            </div>
            <button className={classes.photos__arrow + ' ' + classes.right} onClick={scrollRight}>
                <ArrowLeftIcon />
            </button>

            {selectedIndex !== null && (
                <Modal
                    show={selectedIndex !== null}
                    handleClose={() => setSelectedIndex(null)}
                >
                    <div className={classes.photos__modal}>
                        <button className={classes.photos__nav + ' ' + classes.left} onClick={handlePrev}>
                            <ArrowLeftIcon />
                        </button>
                        <img src={getImageById(imageIds[selectedIndex])} alt="Selected" />
                        <button className={classes.photos__nav + ' ' + classes.right} onClick={handleNext}>
                            <ArrowLeftIcon />
                        </button>
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default Photos;
